import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styles from "../GetInvolved/ResellerForm.module.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { createInvolvedLead, verifyCaptcha } from "../lib/Store";
import ReCAPTCHA from "react-google-recaptcha";
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const ResellerForm = ({
  formType = "Reseller Program",
  onClose,
  onSuccess,
}) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [businessWebsite, setBusinessWebsite] = useState("");
  const [selected, setSelected] = useState([]);
  const [phoneSubmitted, setPhoneSubmitted] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    businessWebsite: "",
  });

  const [status, setStatus] = useState({
    type: "",
    message: "",
  });

  const options = ["Consumer Goods", "BFSI", "Tech Support", "Other"];

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleNameChange = (e) => {
    const raw = e.target.value;
    const cleaned = raw.replace(/[^a-zA-Z\s]/g, "");
    setFullName(cleaned);

    let error = "";

    if (cleaned && cleaned.length < 3) {
      error = "Name must be at least 3 characters.";
    } else if (cleaned.length > 50) {
      error = "Name cannot be more than 50 characters.";
    }

    setErrors((prev) => ({
      ...prev,
      fullName: error,
    }));
  };
  const handleEmailChange = (e) => {
    const raw = e.target.value || "";
    const value = raw.replace(/\s/g, "");
    setEmail(value);
    let error = "";
    if (!value) {
      error = "Email is required.";
    } else if (value.length < 5) {
      error = "Email must be at least 5 characters.";
    } else if (value.length > 70) {
      error = "Email cannot be more than 70 characters.";
    } else if (!emailRegex.test(value)) {
      error = "Please enter a valid email address.";
    }
    setErrors((prev) => ({
      ...prev,
      email: error,
    }));
  };

  const handleWebsiteChange = (e) => {
    setBusinessWebsite(e.target.value);
    if (errors.businessWebsite) {
      setErrors((prev) => ({ ...prev, businessWebsite: "" }));
    }
  };

  // const handlePhoneChange = (value, country) => {
  //   setPhone(value);

  //   const dialCode = country?.dialCode ? `+${country.dialCode}` : "";
  //   setCountryCode(dialCode);

  //   const digitsOnly = (value || "").replace(/[^\d]/g, "");
  //   let national = digitsOnly;

  //   if (country?.dialCode && digitsOnly.startsWith(country.dialCode)) {
  //     national = digitsOnly.slice(country.dialCode.length);
  //   }

  //   setPhoneNumber(national);

  //   if (errors.phoneNumber) {
  //     setErrors((prev) => ({ ...prev, phoneNumber: "" }));
  //   }
  // };

  const validatePhone = (value) => {
    if (!value || value.trim() === "") return "";
    if (value.length < 10) return "Phone number must be at least 10 digits.";

    try {
      const phoneNumber = parsePhoneNumberFromString("+" + value);
      if (!phoneNumber) return "Invalid phone number format.";
      if (!phoneNumber.isValid()) return "Invalid number for selected country.";
      return "";
    } catch (error) {
      return "Invalid phone number.";
    }
  };

  const handlePhoneChange = (value, country) => {
    setPhone(value);

    const dialCode = country?.dialCode ? `+${country.dialCode}` : "";
    setCountryCode(dialCode);

    const digitsOnly = (value || "").replace(/[^\d]/g, "");
    let national = digitsOnly;

    if (country?.dialCode && digitsOnly.startsWith(country.dialCode)) {
      national = digitsOnly.slice(country.dialCode.length);
    }

    setPhoneNumber(national);

    if (phoneSubmitted) {
      const err = validatePhone(value);
      setErrors((prev) => ({ ...prev, phoneNumber: err }));
    } else {
      if (errors.phoneNumber) {
        setErrors((prev) => ({ ...prev, phoneNumber: "" }));
      }
    }
  };

  const handleToggle = (value) => {
    setSelected((prev) => {
      if (prev.includes(value)) {
        return prev.filter((item) => item !== value);
      }
      return [...prev, value];
    });
  };

  const validate = () => {
    const newErrors = {
      fullName: "",
      email: "",
      phoneNumber: "",
      businessWebsite: "",
    };
    let isValid = true;

    if (!fullName.trim()) {
      newErrors.fullName = "Full name is required.";
      isValid = false;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      newErrors.email = "Email is required.";
      isValid = false;
    } else if (!emailPattern.test(email)) {
      newErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    // if (!countryCode || !phoneNumber.trim()) {
    //   newErrors.phoneNumber = "Phone number is required.";
    //   isValid = false;
    // } else if (phoneNumber.length < 5 || phoneNumber.length > 15) {
    //   newErrors.phoneNumber = "Please enter a valid phone number.";
    //   isValid = false;
    // }

    if (!phone || phone.trim() === "") {
      newErrors.phoneNumber = "Phone number is required.";
      isValid = false;
    } else {
      const phoneErr = validatePhone(phone);
      if (phoneErr) {
        newErrors.phoneNumber = phoneErr;
        isValid = false;
      }
    }

    if (businessWebsite.trim()) {
      const urlPattern =
        /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-./?%&=]*)?$/i;
      if (!urlPattern.test(businessWebsite.trim())) {
        newErrors.businessWebsite = "Please enter a valid website URL.";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });
    setPhoneSubmitted(true);
    if (!validate()) {
      setStatus({
        type: "error",
        message: "",
      });
      return;
    }

    if (!captchaToken) {
      setCaptchaError("Please verify that you are not a robot.");
      return;
    }

    setLoading(true);

    const resolvedFormType =
      formType === "Reseller Program" ? "reseller" : formType || "reseller";

    try {
      const captchaRes = await verifyCaptcha(captchaToken);
      if (captchaRes.message !== "Captcha verified") {
        setCaptchaError("Captcha verification failed.");
        setLoading(false);
        return;
      }
      await createInvolvedLead({
        formType: resolvedFormType,
        fullName,
        email,
        countryCode,
        phoneNumber,
        businessWebsite: businessWebsite || null,
        industries: null,
        readyToInvest: selected,
        anyOtherIndustry: null,
        avgDailyHandledCalls: null,
      });

      setFullName("");
      setEmail("");
      setPhone("");
      setPhoneNumber("");
      setCountryCode("");
      setBusinessWebsite("");
      setSelected("");
      setPhoneSubmitted(false);

      if (onClose) onClose();
      if (onSuccess) onSuccess(email);
    } catch (err) {
      console.error(err);
      setStatus({
        type: "error",
        message: "Something went wrong while submitting. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.FormMain}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <label>
          Your Full Name<span className={styles.requiredStar}>*</span>
        </label>
        <div className={styles.fieldWrapper}>
          <input
            type="text"
            placeholder="Your name"
            value={fullName}
            onChange={handleNameChange}
            disabled={loading}
            className={errors.fullName ? styles.errorInput : ""}
            minLength={3}
            maxLength={50}
          />
          {errors.fullName && (
            <p className={styles.errorText}>{errors.fullName}</p>
          )}
        </div>
        <label>
          Valid Email Address<span className={styles.requiredStar}>*</span>
        </label>
        <div className={styles.fieldWrapper}>
          <input
            type="email"
            placeholder="Enter your email address here"
            value={email}
            onChange={handleEmailChange}
            disabled={loading}
            className={errors.email ? styles.errorInput : ""}
            minLength={5}
            maxLength={70}
            onKeyDown={(e) => {
              if (e.key === " ") {
                e.preventDefault();
              }
            }}
          />
          {errors.email && <p className={styles.errorText}>{errors.email}</p>}
        </div>

        <label>
          Phone Number with Country Code
          <span className={styles.requiredStar}>*</span>
        </label>

        {/* <div className={styles.phoneInput}> */}
        <div className={styles.fieldWrapper}>
          <div>
            <PhoneInput
              country={"in"}
              value={phone}
              onChange={handlePhoneChange}
              enableSearch={true}
              inputProps={{
                name: "phone",
                required: true,
              }}
              disabled={loading}
              containerClass={styles.phoneContainer}
              buttonClass={styles.phoneFlagButton}
              inputClass={`${styles.phoneField} ${
                errors.phoneNumber ? styles.errorInput : ""
              }`}
              placeholder="985 XXX 88XX"
            />
          </div>
          {errors.phoneNumber && (
            <p className={styles.errorText}>{errors.phoneNumber}</p>
          )}
        </div>
        <div className={styles.fieldWrapper}>
          <label>Business Website</label>
          <input
            type="text"
            placeholder="https://www.MyBusiness.com"
            value={businessWebsite}
            onChange={handleWebsiteChange}
            disabled={loading}
            className={errors.businessWebsite ? styles.errorInput : ""}
          />
          {errors.businessWebsite && (
            <p className={styles.errorText}>{errors.businessWebsite}</p>
          )}
        </div>
        <div className={styles.mainContainer}>
          <label className={styles.mainLabel}>Industries?</label>

          <div className={styles.checkboxRow}>
            {options.map((option) => (
              <div
                key={option}
                className={`${styles.checkDiv} ${
                  selected.includes(option) ? styles.checked : styles.unchecked
                }`}
              >
                <label className={styles.checkLabel}>
                  <input
                    type="checkbox"
                    checked={selected.includes(option)}
                    onChange={() => handleToggle(option)}
                    className={styles.checkbox}
                    disabled={loading}
                  />
                  {option}
                </label>
              </div>
            ))}
          </div>
        </div>

        {status.message && (
          <p
            className={
              status.type === "success" ? styles.successText : styles.errorText
            }
          >
            {status.message}
          </p>
        )}
        <div className={styles.fieldWrapper}>
          <ReCAPTCHA
            sitekey={SITE_KEY}
            onChange={(token) => {
              setCaptchaToken(token);
              setCaptchaError("");
            }}
          />
          {captchaError && <p className={styles.errorText}>{captchaError}</p>}
        </div>

        <button type="submit" className={styles.callBtn} disabled={loading}>
          <img src="/Svg/shape-btn-form2.svg" alt="btn-shape" />
          <div className={styles.textContent}>
            <h4>{loading ? "Sending..." : "Send to my Inbox"}</h4>
          </div>
        </button>
      </form>
    </div>
  );
};

export default ResellerForm;
